import { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Table } from 'reactstrap';

import api from 'services/api';

import { CircularProgress } from '@material-ui/core';
import toast from 'react-hot-toast';
import { Th, Td } from './styles';
import MaterialItem from '../MaterialItem';
import { DownloadPlanilha } from '../DownloadPlanilha';

interface Item {
  codigo: string;
  descricao: string;
  quantidade: number;
  custoUnitario?: number | null;
  custoTotal?: number | null;
  mostrarCusto?: boolean;
  fabricante?: string;
}

export default function PropostaConfiguracaoMaterialExcluido({
  temFatDireto,
  propostaVersao,
}: {
  temFatDireto: boolean;
  propostaVersao: any;
}): JSX.Element {
  const [loadingMateriais, setLoadingMateriais] = useState(false);
  const [materiais, setMateriais] = useState<Item[]>();

  async function retornaPropostaConfiguracaoMateriais(): Promise<void> {
    setLoadingMateriais(true);

    try {
      const response = await api.get(
        `/proposta/versao/materiais-excluidos-material`,
        {
          params: {
            propostaVersao,
            temFatDireto,
          },
        },
      );

      setMateriais(response.data);
      setLoadingMateriais(false);
    } catch (error) {
      setLoadingMateriais(false);
      setMateriais([]);
      toast.error('Erro ao retornar os materiais excluidos.');
    }
  }

  useEffect(() => {
    if (propostaVersao) {
      retornaPropostaConfiguracaoMateriais();
    }
  }, [propostaVersao]);

  const mostrarCusto =
    materiais && materiais.length > 0 ? materiais[0].mostrarCusto : false;

  function BodyMateriais() {
    const materiaisAgrupados = (materiais || []).reduce((acc, item) => {
      const {
        codigo,
        descricao,
        quantidade,
        custoUnitario,
        custoTotal,
        fabricante,
      } = item;

      if (!acc[codigo]) {
        acc[codigo] = {
          diteCodigo: codigo,
          descricao,
          quantidade,
          custoUnitario,
          custoTotal,
          mostrarCusto,
          fabricante,
        };
      } else {
        acc[codigo].quantidade += quantidade;
        if (mostrarCusto) {
          acc[codigo].custoTotal =
            (acc[codigo].custoTotal ?? 0) + (custoTotal ?? 0);
        }
      }

      return acc;
    }, {} as Record<string, { diteCodigo: string; descricao: string; quantidade: number; custoUnitario?: number | null; custoTotal?: number | null; mostrarCusto?: boolean; fabricante?: string }>);

    const listaFinal = Object.values(materiaisAgrupados || {});

    if (loadingMateriais) {
      return (
        <tr>
          <Td className="text-center" colSpan={mostrarCusto ? 5 : 3}>
            <h5>
              Carregando... <CircularProgress size={14} className="ml-3" />
            </h5>
          </Td>
        </tr>
      );
    }

    if (!materiais?.length) {
      return (
        <tr>
          <Td className="text-center" colSpan={mostrarCusto ? 5 : 3}>
            Não há materiais excluídos
          </Td>
        </tr>
      );
    }

    const formatarMoeda = (valor: number | null | undefined): string => {
      if (valor === null || valor === undefined) return '-';
      return valor.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    };

    const totalCusto = mostrarCusto
      ? listaFinal.reduce((sum, item) => sum + (item.custoTotal ?? 0), 0)
      : 0;

    return (
      <>
        {listaFinal.map(material => (
          <MaterialItem
            key={material.diteCodigo}
            diteCodigo={material.diteCodigo}
            quantidade={material.quantidade}
            materialDesc={material.descricao}
            custoUnitario={material.custoUnitario}
            custoTotal={material.custoTotal}
            mostrarCusto={material.mostrarCusto}
            fabricante={material.fabricante}
          />
        ))}
        {mostrarCusto && (
          <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
            <Td colSpan={4} style={{ textAlign: 'right' }}>
              Total:
            </Td>
            <Td>{formatarMoeda(totalCusto)}</Td>
          </tr>
        )}
      </>
    );
  }

  return (
    <div className="mx-auto">
      <Card>
        <CardBody className="p-1">
          <CardTitle className="text-right mb-2 mt-2">
            <div>
              <DownloadPlanilha
                data={materiais ?? []}
                isLoadingMateriais={loadingMateriais}
              />
            </div>
          </CardTitle>
          <Table bordered responsive>
            <thead>
              <tr>
                <Th>Código</Th>
                <Th>Material</Th>
                <Th>quantidade</Th>
                {mostrarCusto && (
                  <>
                    <Th>Custo Unitário</Th>
                    <Th>Custo Total</Th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              <BodyMateriais />
            </tbody>
          </Table>
          <br />
        </CardBody>
      </Card>
    </div>
  );
}
